(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['exports', 'echarts'], factory);
  } else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
    // CommonJS
    factory(exports, require('echarts'));
  } else {
    // Browser globals
    factory({}, root.echarts);
  }
}(this, function (exports, echarts) {

  if (!echarts) {
    console.log('ECharts is not Loaded');
    return;
  }
  const colorPalette = [
    '#26B99A', '#34495E', '#BDC3C7', '#3498DB',
    '#9B59B6', '#8abb6f', '#759c6a', '#bfd3b7'
  ];
  echarts.registerTheme('green-day', {
    color: colorPalette,
    backgroundColor: '#fff',
    graph: {
      color: colorPalette
    }
  });
}));



// WEBPACK FOOTER //
// src/custom/js/green-day-theme.js